module.exports = __webpack_public_path__ + "img/hr-dead-tree-desert-04.a033de50.png";